import ResumeTypes from './types'
import { HostessResumeState } from './state';

export const fetchResumeStart = () => ({
    type: ResumeTypes.FETCH_START
});

export const fetchResumeSuccess = (data: HostessResumeState) => ({
    type: ResumeTypes.FETCH_SUCCESS,
    payload: data
});

export const fetchResumeFailure = () => ({
    type: ResumeTypes.FETCH_FAILURE
});